import {
    Box,
    Table,
    TableContainer,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
    Spinner,
    Text,
    Button
} from '@chakra-ui/react'
import { Link } from 'react-router-dom';

import React, { Fragment } from 'react'


const AllSearchTags = ({ head, data, isLoading, tenureData }) => {

    // data.sort((a, b) => {
    //     const dateA = new Date(a.billingDate);
    //     const dateB = new Date(b.billingDate);

    //     if (dateA < dateB) {
    //         return 1;
    //     } else if (dateA > dateB) {
    //         return -1;
    //     } else {
    //         return 0;
    //     }
    // });

    // console.log(tenureData[0]?.tenure.id, 'xxxxxxxxxxxxxxxxxxxxx')
     // status str format
     const convertStatus = (str) =>  {
        // Split the string by underscores
        var words = str.split('_');
      
        // Capitalize the first letter of each word
        for (var i = 0; i < words.length; i++) {
          words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1).toLowerCase();
        }
      
        // Join the words with a space
        var result = words.join(' ');
      
        return result;
      }
      


    return (
        <Fragment>

        
            <Box maxW={'full'} my={4} >
                <TableContainer>
                    <Table variant={'simple'} size={'xs'}>
                        <Thead bgColor={'gray.100'}>
                            <Tr bgColor={'#E2DFDF'}>
                                {head.map((h, i) => (
                                    <Th key={i} fontSize={'xs'} py={3} _first={{ paddingLeft: '20px' }} color={'#25282B'}>{h}</Th>
                                ))}
                            </Tr>
                        </Thead>

                        <Tbody>
                            {(data.length > 0) ?
                                <>
                                    {data.map((d, i) => (
                                        <Tr key={i} bgColor={'white'}>
                                            <Td fontSize={'xs'} py={3} pl={5}>
                                            <Link to={`/orders/order/${d.orderId}`} >
                                            <Text color={'blue.500'}>{d?.orderItem?.order?.OrderName.includes('#') ? d?.orderItem?.order?.OrderName : 'Draft' || 'n/a'}</Text>
                                            </Link>
                                            </Td>
                                            <Td fontSize={'xs'} py={3}>
                                                <Link to={`/tenures/order/${d.orderId}/tenure/${tenureData[0]?.tenure.id}`} >
                                                <Text color={'blue.500'} >#{tenureData[0]?.tenure.id.split('-')[4] || 'n/a'}</Text>
                                                </Link>
                                            </Td>
                                            <Td fontSize={'xs'} py={3} >
                                              {d?.orderItem?.productId}
                                            </Td>
                                            <Td fontSize={'xs'} py={3} >{d?.orderItem?.title || 'n/a'}</Td> 
                                            {/* <Td fontSize={'xs'} py={3}>₹{d?.orderItem?.totalPrice}</Td> */}
                                            {/* <Td fontSize={'xs'} py={3}>₹{d?.orderItem?.discount}</Td> */}
                                            <Td fontSize={'xs'} py={3} textAlign={'left'}>₹{d?.orderItem?.finalPrice || 'n/a'}</Td>
                                            {/* <Td fontSize={'xs'} py={3} >₹{d?.orderItem?.refundableDeposit || 'n/a'}</Td> */}
                                            {/* <Td fontSize={'xs'} py={3}>{d?.orderItem?.statusId === null ? 'n/a' : (d?.orderItem?.statusId?.charAt(0).toUpperCase() + d?.orderItem?.statusId?.slice(1).toLowerCase())}</Td> */}
                                            <Td fontSize={{base: 'xs', md: 'sm', lg: 'sm', xl: 'sm', '2xl': 'sm'}} py={3}  textAlign={'left'}>
                                        <Button size={'xs'} cursor={'default'} colorScheme={(d?.orderItem?.statusId === 'ORDER_CREATED' && 'green') ||
                                        (d?.orderItem?.statusId === 'ORDER_PUBLISHED' && 'facebook') || 
                                        (d?.orderItem?.statusId === 'ORDER_DRAFT' && 'purple') || 
                                        (d?.orderItem?.statusId === 'ORDER_VERIFIED' && 'whatsapp') || 
                                        (d?.orderItem?.statusId === 'ORDER_DELIVERED' && 'yellow') || 
                                        (d?.orderItem?.statusId === 'ORDER_CANCELED' && 'red') || 
                                        (d?.orderItem?.statusId === 'ORDER_OUT_FOR_DELIVERY' && 'orange') || 
                                        (d?.orderItem?.statusId === 'ORDER_TRANSIT' && 'messenger') || 
                                        (d?.orderItem?.statusId === 'ORDER_RETURNED' && 'telegram') || 
                                        (d?.orderItem?.statusId === 'ORDER_PENDING_FOR_FULFILLMENT' && 'teal') || 
                                        (d?.orderItem?.statusId === 'ORDER_READY_FOR_FULFILLMENT' && 'linkedin') || 
                                        (d?.orderItem?.statusId === 'ORDER_PICKED' && 'pink') ||
                                        (d?.orderItem?.statusId === 'AWAITING_VERIFICATION' && 'cyan')
                                        }>
                                                {convertStatus(d?.orderItem?.statusId).split(' ').filter((d) => d !== "Order").join(' ')}
                                    </Button>
                                    </Td>
                                        </Tr>
                                    ))}
                                </>
                                :
                               
                                <Tr>
                                    <Td></Td>
                                    <Td></Td>
                                
                                    <Td textAlign={'center'}>
                                    {isLoading.loading === true ?
                                        <Spinner
                                        thickness='4px'
                                        speed='0.65s'
                                        emptyColor='gray.200'
                                        color='blue.500'
                                        size='xl'
                                        mt={4}
                                        ml={6}
                                    
                                    />
                                    :
                                    isLoading.error === true ? <Text fontWeight={'semibold'} color={'red.500'} >Oops we are facing some temporary issue with your request</Text> : <Text  fontWeight={'semibold'} color={'green.500'}>NO DATA AVAILABLE</Text>
                          }
                                    </Td>
                                    <Td></Td>
                                    <Td></Td>
                                    <Td></Td>
                                    
                                </Tr>
                             
                                
                            }
                        </Tbody>
                    </Table>
                </TableContainer>
            </Box>
        </Fragment>
    )
}

export default AllSearchTags
